import * as React from 'react';

function SvgCalendarClock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <rect x={3} y={4} width={18} height={18} rx={2} stroke="currentColor" strokeWidth={1.5} />
      <path d="M3 9h18M8 2v4M16 2v4" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" />
      <circle cx={15.5} cy={16.5} r={4} stroke="currentColor" strokeWidth={1.5} />
      <path d="M15.5 15v2l1.5 1" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default SvgCalendarClock;
